module.exports = __webpack_public_path__ + "img/edit.ede1fac0.svg";